module.exports = __webpack_public_path__ + "static/Sonar_logo_V4-250x131-1e5e4d33b62c7b61dca24e9a27da20c7.png";